import { selectedColorSelector } from "components/shopFeatures/color/colorSelectors"
import { selectedDetailingSelector } from "components/shopFeatures/detailing/detailingSelectors"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import { NextSeo } from "next-seo"
import { useLocation } from "react-router-dom"
import { useTypedSelector } from "store"
import styled, { css } from "styled-components"
import { Desktop, Mobile } from "./MediaQueries"
import { createImageApiUrl } from "./createImageApiUrl"

const maxImageSize = 900

export const MODEL_IMAGE_INDEX = 3

export const StyledModelImageContainer = styled.div<{
  $page?: string
  $isShowRoomsScreens?: boolean
}>`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: ${maxImageSize}px;
  margin-bottom: 18px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: auto !important;
    aspect-ratio: 375 / 270;
    margin-bottom: 0;
  }
  ${(p) =>
    p.$isShowRoomsScreens &&
    css`
      margin-bottom: 0;
    `}
`
export const StyledModelImage = styled.img`
  width: 100%;
  display: block;
  object-fit: contain;

  ${(p) => p.theme.breakpoints.down("lg")} {
    max-height: 344px;
  }
`

const ModelImage = () => {
  const selectedDetailing = useTypedSelector(selectedDetailingSelector)
  const selectedColor = useTypedSelector(selectedColorSelector)
  const { isShowRoomsScreens } = useLayoutContext()
  const { pathname } = useLocation()

  const imageUrl =
    selectedColor?.details.images[MODEL_IMAGE_INDEX].imageUrl ||
    selectedDetailing?.details.image.imageUrl
  if (!imageUrl) return null

  const alt = `${selectedDetailing?.details.modelName}, ${selectedDetailing?.details.name}`
  return (
    <StyledModelImageContainer
      $page={pathname}
      $isShowRoomsScreens={isShowRoomsScreens}
    >
      <NextSeo
        openGraph={{
          images: imageUrl
            ? [
                {
                  url: createImageApiUrl(imageUrl),
                  alt,
                  width: 1200,
                  height: 630,
                },
              ]
            : [],
        }}
      />
      <Mobile>
        <StyledModelImage
          src={`${imageUrl}?width=375`}
          sizes="100vw"
          srcSet={`${imageUrl}?width=375 1x, ${imageUrl}?width=750 2x, ${imageUrl}?width=1125 3x`}
          alt={alt}
        />
      </Mobile>

      <Desktop>
        <StyledModelImage src={`${imageUrl}?width=900`} alt={alt} />
      </Desktop>
    </StyledModelImageContainer>
  )
}

export default ModelImage
